import {
  FETCH_DOWNLOAD_DOCUMENTS_REQUEST,
  FETCH_DOWNLOAD_DOCUMENTS_SUCCESS,
  FETCH_DOWNLOAD_DOCUMENTS_FALUIRE,
} from './downloadDocumentsTypes'

const initialState = {
  loading: false,
  downloadDocumentInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DOWNLOAD_DOCUMENTS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DOWNLOAD_DOCUMENTS_SUCCESS : return {
      ...state,
      downloadDocumentInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DOWNLOAD_DOCUMENTS_FALUIRE : return {
      ...state,
      loading: false,
      downloadDocumentInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
